module.exports = __webpack_public_path__ + "media/images/icon_card-485af09c5b9b0d4de02bba6d61864bac.svg";